<template>
  <div>
    <px-view-header title="Detalhes da cotação" :breadcrumbs="breadcrumbs">
      <template v-slot:before>
        <v-btn class="mb-4 mr-1" icon x-large color="primary" @click="onClickBack">
          <v-icon>
            mdi-arrow-left
          </v-icon>
        </v-btn>
      </template>
    </px-view-header>

    <div v-if="loading">
      <px-circular-loading/>
    </div>

    <div v-if="!loading && cotacao">
      <px-cotacao-frete-detalhes-card :cotacao="cotacao"
                                      :solicitacoes="solicitacoes"
                                      @update="onUpdate"/>
      <px-cotacao-frete-respostas :cotacao="cotacao"/>
    </div>
  </div>
</template>

<script>
import CotacaoFreteDetalhesCard from './CotacaoFreteDetalhesCard.vue';
import CotacaoFreteRespostas from './respostas/CotacaoFreteRespostas.vue';
import CotacaoFreteService from '../cotacao-frete-service';

export default {
  data() {
    return {
      id: this.$route.params.id,
      cotacao: null,
      solicitacoes: null,
      loading: false,
      breadcrumbs: [
        { text: 'Gestão de frete' },
        {
          text: 'Cotações de frete',
          to: '/cotacoes-fretes',
        },
        { text: 'Detalhes da cotação' },
      ],
    };
  },
  methods: {
    onClickBack() {
      this.$router.push({ name: 'main.gestao-frete.cotacoes' });
    },
    onUpdate() {
      this.getCotacao();
    },
    getCotacao() {
      this.loading = true;
      CotacaoFreteService.getCotacao(this.id)
        .then(({ data }) => {
          this.cotacao = data;
          return this.getSolicitacoes();
        })
        .finally(() => {
          this.loading = false;
        });
    },
    getSolicitacoes() {
      CotacaoFreteService.getSolicitacoes(this.id)
        .then(({ data }) => {
          this.solicitacoes = data;
        });
    },
  },
  created() {
    this.getCotacao();
  },
  components: {
    pxCotacaoFreteDetalhesCard: CotacaoFreteDetalhesCard,
    pxCotacaoFreteRespostas: CotacaoFreteRespostas,
  },
};
</script>
